import axios from './index.js'

//提交发票数据
export let postInvoiceSave = (params) => {
    return axios.post(`/invoice/save`,params);
};



// WEBPACK FOOTER //
// ./src/api/invoice.js